import { render } from "./PaginationButtons.vue?vue&type=template&id=6307541a&scoped=true"
import script from "./PaginationButtons.vue?vue&type=script&lang=js"
export * from "./PaginationButtons.vue?vue&type=script&lang=js"

import "./PaginationButtons.vue?vue&type=style&index=0&id=6307541a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6307541a"]])

export default __exports__